module.exports = __webpack_public_path__ + "img/img21.683bc08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img21.jpg
// module id = 287
// module chunks = 0